import {useGetUserProfileQuery} from '../redux/api/locales';
import {PropsWithChildren} from 'react';
import dayjs from 'dayjs';

export default function DateFormat(props: PropsWithChildren) {
  const {data} = useGetUserProfileQuery();
  const dateFormat = data?.language === 'it' ? 'DD/MM/YYYY' : 'YYYY/MM/DD';

  return <>{typeof props?.children === 'string' ? dayjs(props?.children).format(dateFormat) : null}</>;
}